<template>
    <div>
        <el-table
            class="rounded"
            v-loading="loading"
            :data="data"
            align="center"
            border
        >
            <!-- Filial -->
            <el-table-column label="Cód. Filial" width="90" align="left">
                <template slot-scope="scope">
                    <span>{{ scope.row.codigo }}</span>
                </template>
            </el-table-column>

            <!-- Centro distribuição -->
            <el-table-column label="Centro Distribuição" min-width="220" align="left">
                <template slot-scope="scope">
                   <span>{{ scope.row.descricao }}</span>
                </template>
            </el-table-column>

            <!-- Uf -->
            <el-table-column
              label="UF"
              width="60"
              align="left"
            >
                <template slot-scope="scope">
                    <span>{{ scope.row.estado.uf }}</span>
                </template>
            </el-table-column>

            <!-- Status -->
            <el-table-column label="Status" width="100" align="left">
                <template slot-scope="scope">
                    <el-tag 
                        v-if="scope.row.ativo != undefined"
                        size="small"
                        :type="scope.row.ativo == true
                            ? 'success' 
                            : 'danger'"
                    >
                      {{ scope.row.ativo == true ? 'ATIVO' : 'INATIVO' }}
                    </el-tag>
                </template>
            </el-table-column>

            <!-- Criado em -->
            <el-table-column label="Criado em" width="180" align="left">
                <template slot-scope="scope">
                    <div class="d-flex align-items-center">
                        <i class="el-icon-time"></i>
                        <span class="ml-1">{{ formatDate(scope.row.created_at, true) }}</span>
                    </div>
                </template>
            </el-table-column>

            <!-- Criado em -->
            <el-table-column label="Atualizado em" width="180" align="left">
                <template slot-scope="scope">
                    <div class="d-flex align-items-center">
                        <i class="el-icon-time"></i>
                        <span class="ml-1">{{ formatDate(scope.row.updated_at, true) }}</span>
                    </div>
                </template>
            </el-table-column>

            <!-- Acoes -->
            <el-table-column
              fixed="right"
              align="right"
              width="50"
            >
              <div slot="header" style="width: 100%;">
                  <i class="el-icon-menu" />
              </div>

              <template slot-scope="scope">
                    <div class="d-flex justify-content-between">
                        <el-popover placement="bottom-end" trigger="hover">
                            <el-button
                                slot="reference"
                                size="mini" 
                                type="info" 
                                plain 
                                circle
                                :disabled="loading"
                            >
                                <i class="el-icon-more"></i>
                            </el-button>

                            <div :style="{ display: 'flex', alignItems: 'flex-start', flexDirection: 'column', gap: '4px', maxWidth: '300px' }">
                                <div :style="{ width: '100%'}">
                                    <el-button
                                        slot="reference"
                                        size="mini"
                                        type="primary"
                                        plain
                                        :style="{ width: '100%'}"
                                        @click="dispatchRegionCd(scope.row.id)"
                                    >
                                        <i class="el-icon-right"></i>
                                        <i class="el-icon-map-location"></i>
                                        <span>Ver regiões</span>
                                    </el-button>
                                </div>

                                <div :style="{ width: '100%'}">
                                    <el-button
                                        slot="reference"
                                        size="mini"
                                        type="warning"
                                        plain
                                        @click="dispatchCd(scope.row.id)"
                                        :style="{ width: '100%'}"
                                    >   
                                        <i class="el-icon-edit"></i>
                                        <span>Editar</span>
                                    </el-button>
                                </div>
                            </div>
                        </el-popover>
                    </div>
              </template>
            </el-table-column>

            <template slot="empty">
                <el-empty description="Nenhum centro de distribuição disponível"></el-empty>
            </template>
        </el-table>

        <!-- Paginacao -->
        <el-row class="mt-3">
            <el-col>
                <el-pagination
                  background
                  :current-page.sync="pagination.data.currentPage"
                  :page-sizes="pagination.pageSizes"
                  :page-size="pagination.data.perPage"
                  layout="total, sizes, prev, pager, next"
                  :total="pagination.total"
                  @current-change="handlePageChange"
                  @size-change="handleSizeChange"
                />
            </el-col>
        </el-row>

        <!-- CD Edit -->
        <CdEditModal ref="cdEditModal" @updated="fetch"/>

        <!-- Regions List -->
        <CdRegionShowModal ref="cdRegionShowModal"/>
    </div>
</template>

<script>
    // Components
    import CardBase from "@/components/_macro/CardBase.vue";
    import { Empty, Table, TableColumn, Notification, Popover } from "element-ui";

    import CdEditModal from "./CdEditModal.vue";
    import CdRegionShowModal from "./CdRegionShowModal.vue";

    // Api
    import { CentroDistribuicaoApi } from "@/api/CentroDistribuicaoApi.js";
    const centroDistribuicaoApi = new CentroDistribuicaoApi();

    // Utils
    import { formatDate } from "@/util/formatters";

    export default {
        name: "cd-list",
        data() {
            return {
                data: [],
                loading: false,
                filters: {
                    orderBy: 'latest',
                },
                pagination: {
                    data: {
                        currentPage: 1,
                        perPage: 15,
                    },
                    pageSizes: [15, 50, 75, 100],
                    total: 0
                },
            }
        },
        methods: {
            async fetch() {
                try {
                    this.loading = true;

                    const res = await centroDistribuicaoApi.list({
                        ...this.filters,
                        ...this.pagination.data
                    });

                    this.data = res.data;
                    this.pagination.total = res.total;
                } catch (err) {
                    Notification.error({
                        title: 'Erro',
                        message: 'Não foi possível obter os centros de distribuição!'
                    });
                } finally {
                    this.loading = false;
                }
            },
            async dispatchCd(cdId) {
                this.$refs.cdEditModal.cdId = cdId;

                const elLoading = this.$loading({ lock: true })

                await this.$refs.cdEditModal.getCd();

                elLoading.close();

                return this.$refs.cdEditModal.toggleModal();
            },
            async dispatchRegionCd(cdId) {
                this.$refs.cdRegionShowModal.cdId = cdId;
                
                const elLoading = this.$loading({ lock: true });

                elLoading.close();

                this.$refs.cdRegionShowModal.toggleModal();
            },
            /*
            * Pagination 
            *
            */
            handlePageChange(page) {
                this.pagination.data.currentPage = page;
                this.fetch();
            },
            handleSizeChange(val) {
                this.pagination.data.perPage = val;
                this.pagination.data.currentPage = 1;
                this.fetch();
            },
            formatDate
        },
        watch: {
            "filters": {
                handler(_newValue) {
                    this.fetch(_newValue);
                },
                deep: true,
            }
        },
        mounted() {
            this.fetch();
        },
        components: {
            CardBase,
            CdEditModal,
            CdRegionShowModal,
            [Empty.name]: Empty,
            [Table.name]: Table,
            [TableColumn.name]: TableColumn,
            [Notification.name]: Notification
        },
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/_macro/cd/CdList.vue